// @ is an alias to src
import "@/App.scss";
import Navbar from "@/components/Common/Navbar/Navbar.vue";
import Header from "@/components/Common/Header/Header.vue";
import MobileNavbar from "@/components/Common/MobileNavbar/MobileNavbar.vue";
import ChatbotWidget from "@/components/Common/ChatbotWidget/ChatbotWidget.vue";
export default {
  name: "App",

  components: {
    ChatbotWidget,
    MobileNavbar,
    Navbar,
    Header
  },
  data: () => ({ mobileMenuOpen: false, reloadRouterViewKey: false }),
  async mounted() {
    await this.$store.dispatch("getGlobalEoConfig");
  },
  computed: {
    selectedModuleClass() {
      const currentPath = this.$route.path;

      if (currentPath.includes("poi-region-edit")) return "poi_module";

      const moduleFromPath = this.modules?.find(module =>
        currentPath.startsWith(`/${module.id}`)
      );
      if (moduleFromPath) {
        return moduleFromPath?.class || "default";
      }
    },
    globalConfig() {
      return this.$store.state.globalEoConfig;
    },
    session() {
      return this.$store.state.session;
    },
    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set(value) {
        this.$store.dispatch("setSnackbar", value);
      }
    },
    snackbarColor() {
      return this.$store.state.snackbarColor;
    },
    snackbarText() {
      return this.$store.state.snackbarText;
    },
    modules() {
      return this.$store.state.modules;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    selectedPrincipalId() {
      return this.$store.state.selectedPrincipal?.id;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isChatbotEnabled() {
      return this.$store.state.llmConfig?.isChatbotEnabled || false;
    },
    chatbotApiKey() {
      return this.$store.state.llmConfig?.chatbotApiKey || "";
    },
    chatbotTitle() {
      const defaultTitle = "Chat Assistant";
      const apiKey = this.chatbotApiKey;
      if (!apiKey) {
        return defaultTitle;
      }

      const llmApiKeys = this.$store.state.llmApiKeys || [];
      const matchingKey = llmApiKeys.find(item => item?.apiKey === apiKey);
      const description = matchingKey?.description?.trim();
      return description || defaultTitle;
    }
  },
  methods: {
    toggleMobileMenu(value) {
      this.mobileMenuOpen = value;
    },
    moduleAccessSignature(modules) {
      if (modules === "regionEdit") return "regionEdit";
      if (!Array.isArray(modules)) return "";
      return modules
        .map(module => `${module?.id ?? ""}|${module?.path ?? ""}`)
        .sort()
        .join(",");
    },
    reloadRouterView() {
      this.reloadRouterViewKey = !this.reloadRouterViewKey;
    },
    async redirectToDashboard() {
      await this.$router.replace("/");
    }
  },
  watch: {
    async selectedPrincipalId() {
      await this.$store.dispatch("getNavbarItems");
      await this.$store.dispatch("getLLMConfig");
      await this.$store.dispatch("getLLMApiKeys");
    },
    async modules(newValue, oldValue) {
      const hasPreviousModules =
        oldValue === "regionEdit" ||
        (Array.isArray(oldValue) && oldValue.length > 0);
      const oldSignature = this.moduleAccessSignature(oldValue);
      const newSignature = this.moduleAccessSignature(newValue);

      if (newValue === "regionEdit") {
        newValue = [
          {
            path: "/poi-region-edit",
            name: "regionEdit"
          }
        ];
      }
      if (
        this.$router.currentRoute.path === "/" ||
        this.$router.currentRoute.path === "/login" ||
        this.$router.currentRoute.path === "/changePw" ||
        this.$router.currentRoute.path === "/user/settings"
      ) {
        return;
      }
      const moduleExistsForPrincipal = newValue?.some(module =>
        this.$router.currentRoute.path.startsWith(module.path)
      );
      if (moduleExistsForPrincipal) {
        if (!hasPreviousModules || oldSignature === newSignature) {
          return;
        }
        this.reloadRouterView();
      } else {
        await this.$store.dispatch("createError", {
          text:
            "Dieses Produkt steht für den gewählten Mandanten nicht zur Verfügung."
        });
        await this.redirectToDashboard();
      }
    }
  }
};
